const buttonDropdown = {
  "dropdown-menu": {
    composes: "dropdown-menu",
    ".dropdown-menu&": {
      "margin-top": "38px",
    },
  },
  "dropdown-menu-opened": {
    ".dropdown-menu&": {
      display: "block",
    },
  },
  "dropdown-menu-closed": {
    ".dropdown-menu&": {
      display: "none",
    },
  },
  "dropdown-menu-right": {
    ".dropdown-menu&": {
      right: "0",
    },
  },
  "dropdown-menu-container": {
    composes: "btn-group",
  },
  "left-space": {
    "margin-left": "5px",
  },
  "bottom-space": {
    "margin-bottom": "5px",
  },
  "dropdown-menu-button": {
    composes: "btn btn-outline-dark dropdown-toggle",
  },
};

export default buttonDropdown;
